import { StyledContainer, StyledTitle, StyledWrapper } from "components/general/stylingHero";
import Link from "next/link";
import styled from "styled-components";

const StyledSubtitle = styled.div`
  font-size: 1.5rem;
  color: #604aff;
  letter-spacing: 3px;
  font-weight: 500;
`;
const StyledRow = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 3rem;
  margin-bottom: 4rem;
`;
const StyledBlock = styled.div`
  background: var(--raised-background-color);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  width: 290px;
  padding: 2rem 3rem 3.5rem 3rem;
  gap: 1rem;
  h3 {
    font-size: 5rem;
    font-weight: 500;
    margin: 0;
    color: #604aff;
  }
  h4 {
    font-size: 1.5rem;
    margin: 0;
  }
  p {
    margin: 0;
  }
`;
const StyledBlockLink = styled(StyledBlock)`
  text-decoration: none;
  color: var(--text-color);
  transition: transform 0.2s ease;
  &:hover {
    text-decoration: none;
  }
  &:hover {
    transform: scale(1.05, 1.05);
  }
`;
const Hero = () => {
  return (
    <StyledWrapper>
      <StyledContainer style={{ flexDirection: "column" }}>
        <StyledTitle>How do I start?</StyledTitle>
        <StyledSubtitle>EASY STEPS TO GET STARTED</StyledSubtitle>
        <StyledRow>
          <StyledBlock>
            <h3>01</h3> <h4>Sign up</h4>
            <p>
              Sign up for Redact, visit your <Link href="/account">account page</Link> and enroll
              into the affiliate program!
            </p>
          </StyledBlock>
          <StyledBlock>
            <h3>02</h3> <h4>Use Redact Graphics</h4>
            <p>
              Explore the <Link href="/press-kit">press kit</Link> to download official Redact
              graphics and promote Redact!
            </p>
          </StyledBlock>
          <StyledBlock>
            <h3>03</h3> <h4>Get money!</h4>
            <p>Cash out your hard earned referrals</p>
          </StyledBlock>
          <StyledBlockLink as="a" href="/account" target="_blank" rel="noopener noreferrer">
            <h3>Go</h3> <h4>Get started now</h4>
            <p>
              <svg
                style={{ fill: "#604aff", width: "4rem", height: "auto" }}
                clipRule="evenodd"
                fillRule="evenodd"
                strokeLinejoin="round"
                strokeMiterlimit={2}
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.523 18.787l6.255-6.26a.747.747 0 000-1.06l-6.255-6.258a.75.75 0 00-1.056.004.746.746 0 00-.004 1.056l4.978 4.978H3.749a.75.75 0 000 1.5h14.692l-4.979 4.979a.746.746 0 00.006 1.054.752.752 0 00.533.222c.19 0 .378-.072.522-.215z"
                  fillRule="nonzero"
                />
              </svg>
            </p>
          </StyledBlockLink>
        </StyledRow>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Hero;
